export default function processDirective() {
  return {
    template: require('./approve-process.html'),
    scope: {
      customerId: '<',
      assessment: '=',
      process: '=',
      tooltipAppendToSelector: '@',
      assignedAssets: '<',
      assetTypes: '<'
    },
    controller: 'ApprovePRAProcessController',
    controllerAs: 'approveProcessVM',
    bindToController: true,
    replace: true,
  };
}
